import tr from "../language/tr.json"

const keys: Record<string, string> = tr

export default function (key: string) {

    return keys[key]
}